import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import avatar from '../../common/helpers/avatar';

export default class PicturePreviewModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.img = vnode.attrs.imgList;
    let imageElements = document.querySelectorAll('.Post-body-lin img');
    let imageUrls = [];
    // 遍历所有找到的图片元素
    imageElements.forEach(function (imageElement) {
      // 获取图片的src属性，这就是图片的URL
      let imageUrl = imageElement.src;
      // 添加到数组中
      imageUrls.push(imageUrl);
    });
    this.imgList = imageUrls;
    this.imgIndex = this.imgList.indexOf(this.img);
    this.onImgUrl = this.imgList[this.imgIndex];
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.isAtTopEdge = false;
    this.isAtBottomEdge = false;
    this.touchStartY = 0;
    setTimeout(() => {
      this.handleTouch();
    }, 100);
  }

  className() {
    return 'picture-preview-modal';
  }
  oncreate(vnode){
    super.oncreate(vnode)
  }
  title() {
    return;
  }
  hide(vnode){
    super.hide(vnode);
    document.documentElement.classList.remove('modal-open');
  }
  content() {
    return (
      <div className="picture-preview-box" id="imageSlider" onclick={()=>{this.hide()}}>
        <img src={this.onImgUrl}></img>
      </div>
    );
  }
  // 处理滑动
  handleTouch() {
    const slider = document.getElementById('imageSlider');

    slider.addEventListener('touchstart', this.handleTouchStart);
    slider.addEventListener('touchmove', this.handleTouchMove);
    slider.addEventListener('touchend', this.handleTouchEnd);
  }
  handleTouchStart = (event) => {
    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
    const slider = document.getElementById('imageSlider');
    this.checkEdges(slider);
  };
  handleTouchMove = (event) => {
    // 检查滑块是否已经到达上或下边界
    if ((this.isAtTopEdge && event.touches[0].clientY > this.touchStartY) || (this.isAtBottomEdge && event.touches[0].clientY < this.touchStartY)) {
      // 如果是，则阻止默认的滚动行为
      event.preventDefault();
    }
  }
  handleTouchEnd = (event) => {
    this.touchEndX = event.changedTouches[0].clientX;
    const diffX = this.touchStartX - this.touchEndX;

    if (diffX > 50) {
      // 左滑
      this.nextImage();
    } else if (diffX < -50) {
      // 右滑
      this.prevImage();
    }
    this.checkEdges(event);
  };
  nextImage() {
    if (this.imgIndex < this.imgList.length - 1) {
      this.imgIndex++;
      this.onImgUrl = this.imgList[this.imgIndex];
      m.redraw();
    }
  }

  prevImage() {
    if (this.imgIndex > 0) {
      this.imgIndex--;
      this.onImgUrl = this.imgList[this.imgIndex];
      m.redraw();
    }
  }
  checkEdges(slider) {
    // 检查滚动位置
    const scrollPosition = slider.scrollTop;
    const scrollHeight = slider.scrollHeight;
    const clientHeight = slider.clientHeight;

    // 设置边界状态
    this.isAtTopEdge = scrollPosition === 0;
    this.isAtBottomEdge = scrollPosition + clientHeight >= scrollHeight;
  }
}
